import { cn } from '@/lib/utils';
import { formatCount } from './format';

interface MiniSplitProps {
  left: number;
  right: number;
  label: string;
  className?: string;
}

/** Narrowest the bar gets in px, and roughly how wide one 12px digit is. */
const WIDTH = 213;
const DIGIT = 7;

/** Compact two-part bar for table cells (in-scope vs out of scope, human vs AI). */
export function MiniSplit({ left, right, label, className }: MiniSplitProps) {
  const total = left + right;
  if (total === 0) return <span aria-label={label} className='text-gray-800'>—</span>;
  const leftShare = (left / total) * 100;
  const leftText = formatCount(left);
  // The right number sits over its own segment, or at the bar's end when the left one would run into it.
  const roomy = (leftShare / 100) * WIDTH >= leftText.length * DIGIT + 12;
  return (
    <div className={cn('flex w-[213px] flex-col gap-1.5', className)} aria-label={label}>
      <div className='flex justify-between gap-1.5 text-xs leading-4 tabular-nums text-gray-800'>
        <span className='min-w-fit' style={roomy ? { width: `${leftShare}%` } : undefined}>{leftText}</span>
        <span className={roomy ? 'flex-1' : undefined}>{formatCount(right)}</span>
      </div>
      <div className='flex h-2.5 gap-1.5 rounded-full bg-gray-300 p-0.5'>
        {left > 0 ? <div className='rounded-[6px] bg-indigo-700' style={{ width: `${leftShare}%` }} /> : null}
        {right > 0 ? <div className='flex-1 rounded-[6px] bg-indigo-300' /> : null}
      </div>
    </div>
  );
}
